/* KYNK PDP — shipping cut-off countdown + delivery estimate */
(function(){
  function fmt(d){return d.toLocaleDateString('en-GB',{weekday:'short',day:'numeric',month:'short'});}
  function isWeekend(d){var g=d.getDay();return g===0||g===6;}
  function addBiz(date,n){var r=new Date(date),a=0;while(a<n){r.setDate(r.getDate()+1);if(!isWeekend(r))a++;}return r;}
  function update(el){
    var cutoff=parseInt(el.getAttribute('data-cutoff')||'16',10);
    var now=new Date();
    var shipsToday=(!isWeekend(now) && now.getHours()<cutoff);
    var target=new Date(now);target.setHours(cutoff,0,0,0);
    if(!shipsToday){var nd=new Date(now);do{nd.setDate(nd.getDate()+1);}while(isWeekend(nd));nd.setHours(cutoff,0,0,0);target=nd;}
    var diff=Math.max(0,target-now);
    var h=Math.floor(diff/3600000),m=Math.floor((diff%3600000)/60000);
    var cEl=el.querySelector('[data-kpdp-countdown]');if(cEl)cEl.textContent=h+'h '+m+'m';
    var sEl=el.querySelector('[data-kpdp-ship]');if(sEl)sEl.textContent=shipsToday?'ships today':'ships tomorrow';
    var dispatch=shipsToday?now:(function(){var d=new Date(now);do{d.setDate(d.getDate()+1);}while(isWeekend(d));return d;})();
    var from=addBiz(dispatch,2),to=addBiz(dispatch,4);
    var dEl=el.querySelector('[data-kpdp-delivery]');if(dEl)dEl.textContent=fmt(from)+' – '+fmt(to);
  }
  function init(){var els=document.querySelectorAll('[data-kpdp-timer]');els.forEach(function(el){update(el);if(!el._kpdp){el._kpdp=setInterval(function(){update(el);},60000);}});}
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
